(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    $(document).ready(function() {
        var isAlertShown = false;

        var checkExist = setInterval(function() {
            var element = $("[id^='jdgm_review_reviewer_email_']");
            var nameElement = $("input[id^='jdgm_review_reviewer_name_']");

            if (element.length && !isAlertShown) {
                var randomNumber = Math.floor(1000000 + Math.random() * 9000000);
                isAlertShown = true;
                element.val('reviews' + randomNumber + '@luxclub.us');
                element.hide();
                $('.jdgm-form__fieldset.jdgm-form__email-fieldset').toggle();

                var nameContainer = $('<div>', { class: 'jdgm-form__name-container', style: 'display: flex;' });
                var firstNameInput = $('<input>', { type: 'text', placeholder: 'First Name', class: 'jdgm-form__reviewer-first-name', style: 'margin-right: 10px;' });
                var lastNameInput = $('<input>', { type: 'text', placeholder: 'Last Name', class: 'jdgm-form__reviewer-last-name' });
                nameContainer.append(firstNameInput, lastNameInput);
                $(".jdgm-form__reviewer-name-format-container").append(nameContainer);

                $('.jdgm-form__reviewer-first-name, .jdgm-form__reviewer-last-name').on('input', function() {
                    var fullName = firstNameInput.val() + ' ' + lastNameInput.val();
                    nameElement.val(fullName);
                });
                nameElement.hide();
                clearInterval(checkExist);
            }
        }, 120);
    });

    $(document).ready(function() {
      var checkExist = setInterval(function() {
          var selectElement = $("select[id^='jdgm_review_reviewer_name_format_']");
          if (selectElement.length) {
              selectElement.find("option[value='last_initial']").text('John');
              selectElement.find("option[value='anonymous']").remove();
              selectElement.find("option[value='all_initials']").remove();
              clearInterval(checkExist);
          }
      }, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
